export default "__VITE_ASSET__Dsi62QaX__"